import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent extends DestructorComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService
  ) {
    super();
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {
    console.log('Forgot Password component initialized');
  }

  /**
   * Handle form submission for forgot password
   */
  onSubmit(): void {
    // Mark all fields as touched to show validation errors
    this.forgotPasswordForm.markAllAsTouched();

    if (this.forgotPasswordForm.valid) {
      this.isLoading = true;
      const email = this.forgotPasswordForm.get('email')?.value;

      // Call AuthService ForgotPassword method
      this.subscriptions.push(
        this.authService.ForgotPassword({ email }).subscribe({
          next: (response: any) => {
            this.isLoading = false;
            console.log('Password reset email sent successfully:', response);

            // Show success message
            Swal.fire({
              text: response.message || "We have sent a password reset link to your email.",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            }).then((result: any) => {
              if (result.isConfirmed) {
                // Reset the form
                this.forgotPasswordForm.reset();

                // Close the modal
                this.closeModal();
              }
            });
          },
          error: (error: any) => {
            this.isLoading = false;
            console.error('Error sending password reset email:', error);

            // Show error message
            const errorMessage = error.error?.message ||
                               error.message ||
                               "Sorry, looks like there are some errors detected, please try again.";

            Swal.fire({
              text: errorMessage,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            });
          }
        })
      );
    }
  }

  /**
   * Helper method to close modal
   */
  closeModal(): void {
    const modalElement = document.getElementById('kt_modal_forgot_password');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }
}
